import { useMutation } from '@tanstack/react-query'

import { deleteRampCurve } from '@/features/resource/endpoints/resources'

export function useDeleteRampCurveMutation(resourceId: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (rampCurveId: string) => deleteRampCurve(resourceId, rampCurveId),
  })

  return {
    deleteRampCurve: mutateAsync,
    ...mutationResult,
  }
}
